import { useTheme } from '@mui/material/styles';
import H1Style from '../../../assets/themes/h1Style';
import H2Style from '../../../assets/themes/h2Style';


const Styles= () => {
  const theme = useTheme();
  const h1Style = H1Style(theme)
  const h2Style = H2Style(theme)

  return {
    title: { ...h1Style},
    subtitle: { ...h2Style},
    tableHead:{
      backgroundColor: theme.palette.primary.main,
      color: 'white'
    },
  
  }
}

export default Styles;